// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add_class .el-form-item[data-v-ebd110da] {\n  width: 50%;\n  float: left;\n}", ""]);
// Exports
module.exports = exports;
